// general hapi reset styles
require('./public/css/reset.scss');

class HAPI_PageCycle {
	static ready = false;
	static cb_onload = new Set()
	static cb_refresh = new Set()
	static neededRessources = new Set()
	static loadedRessources = new Set()
	static _requireQueue = {};

	static domReady(cb) {
		//console.log('document.readyState',document.readyState);
		if ((!document.readyState || document.readyState == "interactive" || document.readyState == "complete"))
			cb()
		else
			document.addEventListener("DOMContentLoaded", cb);
	}

	static async onLoad(cb=null) {
		if(HAPI_PageCycle.ready)
			return cb(); // si la page est déjà prête on execute immédiatement le CallBack

		if(typeof cb === "function")
			HAPI_PageCycle.cb_onload.add(cb);
	}
	static async load() {
		HAPI_PageCycle.cb_onload.forEach(function(cb){ cb(); })
	}

	static async onRefresh(cb) {
		if(typeof cb === "function")
			HAPI_PageCycle.cb_refresh.add(cb);
	}
	static async refresh(container=null) {
		HAPI_PageCycle.cb_refresh.forEach(function(cb){ cb(container); })
	}

	static async init() {
		var ENV_PSPEED = window.ENV_PSPEED ? window.ENV_PSPEED : false;

		//jquery as first dependency
		await HAPI_PageCycle.loadMainScript("https://code.jquery.com/jquery-3.7.1.min.js",'jquery');
		// hapi essentials library
		await HAPI_PageCycle.loadMainScript("/assets/dist/public.00.essentials.js",'hapi-essential');

		// if not ENV_CRAWLER_PAGESPEED
		var librarySources = ENV_PSPEED ? [] : [
			HAPI_PageCycle.loadMainScript('https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/js/select2.min.js','select2'),
			HAPI_PageCycle.loadMainScript('css:https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/css/select2.min.css','select2-css'),

			HAPI_PageCycle.loadMainScript("/assets/dist/public.01.extra.js",'hapi-extra'),
			HAPI_PageCycle.loadMainScript("/assets/dist/public.02.intl-tel-input.js",'intl-tel-input'),
			HAPI_PageCycle.loadMainScript("/assets/dist/public.10.bxslider.js",'bxslider'),
			HAPI_PageCycle.loadMainScript("/assets/dist/public.10.fancybox.js",'fancybox'),
			HAPI_PageCycle.loadMainScript("/assets/dist/public.10.vegas.js",'vegas'),
		]

		Promise.all(librarySources).then(async function(){

			// ENV_CRAWLER_PAGESPEED
			if(!ENV_PSPEED)
			{
				await HAPI_PageCycle.loadMainScript("/assets/dist/public.20.hapi-core.js",'hapi-core');
			}

			await HAPI_PageCycle.loadMainScript("/assets/dist/public.99.runner.js",'hapi-runner');
			HAPI_PageCycle.domReady(() => {
				HAPI_PageCycle.ready = true;
				HAPI_PageCycle.load() // called once the page is loaded (and never after)
				HAPI_PageCycle.refresh() // called on each HAPI ui refresh cycle (even on startup)
				if(!ENV_PSPEED)
				{
					HAPI_PageCycle.loadAdditionnalScript("/assets/dist/public.30.gmap-leaflet.js",'gmap-leaflet');
				}
				HAPI_PageCycle.__private_loadAdditionnalScript_Queue();
			})
		})
	};

	static async require(aliases) {
		aliases = typeof aliases === "string" ? [aliases] : aliases;
		const queue = [];
		for(let i = 0; i<aliases.length; i++) {
			queue.push(HAPI_PageCycle.__private_require(aliases[i]))
		}
		return Promise.all(queue);
	}
	static async __private_require(alias) {
		return new Promise((resolve, reject) => { 
			const aliasTtl = alias.ttl ? alias.ttl : 0;
			const aliasName = alias.name ? alias.name : alias;

			// déjà chargé on résoud la promesse immédiatement
			if(HAPI_PageCycle.isLoaded(aliasName))
				resolve();

			// sinon on devra attendre l'évènement adéquat
			HAPI_PageCycle._requireQueue[aliasName] = HAPI_PageCycle._requireQueue[aliasName] ?? new Set()
			HAPI_PageCycle._requireQueue[aliasName].add(resolve)
			if(aliasTtl>0)
				setTimeout(reject, aliasTtl)
		})
	}

	static isLoaded(alias) {
		return HAPI_PageCycle.loadedRessources.has(alias)
	}
	static markAsloaded(alias) {
		console.log(`HAPI_PageCycle "${alias}" loaded`);
		HAPI_PageCycle.loadedRessources.add(alias);
		const queue = HAPI_PageCycle._requireQueue[alias]
		if(queue)
		{
			queue.forEach(function(resolve){resolve()})
			delete HAPI_PageCycle._requireQueue[alias];
		}
	}

	static loadMainScript(src,alias=null) {
		return HAPI_PageCycle.__private_loadAdditionnalScript(src,alias)
	}

	static loadAdditionnalScript(src,alias=null) {
		if(HAPI_PageCycle.ready)
			return HAPI_PageCycle.__private_loadAdditionnalScript(src,alias)
		else
			return HAPI_PageCycle.neededRessources.add({src,alias})
	}

	static __private_loadAdditionnalScript_Queue() {
		HAPI_PageCycle.neededRessources.forEach(function(el) {
			HAPI_PageCycle.__private_loadAdditionnalScript(el.src,el.alias)
		})
	}

	static __private_loadAdditionnalScript(src,alias=null) {
		const localSrc = src
		const localAlias = alias
		return new Promise((resolve, reject) => {
			const timeout = setTimeout(reject,10*1000);
			if(localSrc.match(/^css:/))
			{
				const el = document.createElement('link');
				el.href = localSrc.replace(/^css:/,'');
				el.rel = 'stylesheet';
				document.body.append(el);
				HAPI_PageCycle.markAsloaded(alias)
				clearTimeout(timeout)
				resolve();
			}
			else
			{
				const el = document.createElement('script');
				el.src = localSrc
				el.async = true;
				el.onload = () => {
					HAPI_PageCycle.markAsloaded(alias)
					clearTimeout(timeout)
					resolve();
				}
				//console.log('HAPI_PageCycle append script tag',{localAlias, localSrc});
				document.body.append(el);
			}
		})
	}
}
// expose on global scope
window.HAPI_PageCycle = HAPI_PageCycle;

// alias for retro compatibility
window.HAPI_RefreshJavascriptBehaviors = HAPI_PageCycle.refresh
window.HAPI_Add_RefreshJavascriptBehaviors = HAPI_PageCycle.onRefresh

// Init HAPI Page Cycle
HAPI_PageCycle.domReady(HAPI_PageCycle.init)